export function SocialProofTicker() {
  return (
    <div className="w-full overflow-hidden bg-primary/5 border-y border-primary/10">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-center text-sm">
          <span className="text-muted-foreground">
            <span className="font-bold text-foreground">PingEarn is going viral</span>, now is your chance to join
          </span>
        </div>
      </div>
    </div>
  );
}
